import { NodeContext, PathContext } from "@dashboard/contexts/pathContext";
import { useContextError } from "common-frontend-components";

export function useCycle() {
    return useContextError(PathContext.name, PathContext);
}

export function useNode() {
    return useContextError(NodeContext.name, NodeContext);
}
